module.exports = __webpack_public_path__ + "static/media/pin_red.6bdd9f7d.svg";